import * as actionTypes from "../../actions/actionTypes";

const controlsInitialState = {
  menu: false,
  takeScreenshot: false,
  notes: false,
};

const initialState = {
  requests: [],
  scheduled: [],
  completed: [],
  totalPages: 1,
  page: 0,
  appointmentDetail: { appointmentDate: new Date() },
  control: controlsInitialState,
  visitNow: {},
};

const appointments = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_APPOINTMENT_DATA: {
      return { ...state, ...action.payload };
    }
    case actionTypes.SET_REQUESTS_APPOINTMENTS:
      return { ...state, ...action.payload };
    case actionTypes.RESET_APPOINTMENT_DETAIL:
      return { ...state, appointmentDetail: initialState.appointmentDetail };
    case actionTypes.REMOVE_APPOINTMENT_DATA: {
      const appointments = { ...state.requests };
      const payload = action.payload.appointmentObj;
      const appointment = appointments[payload?.appointmentDate];

      const updateAppointments = appointment.filter(
        apt => apt.id !== payload?.id
      );

      appointments[payload?.appointmentDate] = updateAppointments;

      const noOfRequestedAppointments = state.noOfRequestedAppointments - 1;

      return { ...state, requests: appointments, noOfRequestedAppointments };
    }
    case actionTypes.RESET_REQUESTED_APPOINTMENT:
      return { ...state, requests: [], totalPages: 1 };
    case actionTypes.CHANGE_CONTROL:
      return { ...state, control: { ...state.control, ...action.control } };
    case actionTypes.CLEAR_CONTROL:
      return { ...state, control: controlsInitialState };
    case actionTypes.SET_VISIT_NOW:
      return { ...state, visitNow: action.payload };

    default:
      return state;
  }
};

export default appointments;
